import { ReactNode } from 'react';
import styles from './Row.module.css';

export default function Row({ children }: { children: ReactNode }) {
  return (
    <div className={styles['row']}>
      {children}
    </div>
  )
}
